<template>
    <div class="h-screen overflow-hidden">
        <RouterView />
        <Toast position="top-right" />
        <ConfirmDialog />
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";

const toast = useToast();
const confirm = useConfirm();

onMounted(() => {
    // Imposta il tema iniziale
    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    document.documentElement.classList.toggle('dark', isDark)
});
</script>